import React from 'react';
import IconButton from './IconButton';

const ForwardButton = ({ disabled, iconOnly, onClick }) => (
  <IconButton
    className="aridhia-forward-button"
    disabled={disabled}
    icon
    iconName="chevron right"
    iconOnly={iconOnly}
    messageId="actions.next"
    onClick={onClick}
  />
);

export default ForwardButton;
